import { useEffect, useState } from "react";
import { Radio } from "lucide-react";

export const LiveProgress = ({ batch, found, target, at }) => {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 1000); return () => clearInterval(t); }, []);
  const total = Number(batch?.total ?? batch?.count ?? target) || target;
  const pct = Math.min(100, Math.max(8, (found / total) * 100));
  const ago = at ? Math.max(0, Math.round((Date.now() - at) / 1000)) : null;
  const msg = batch?.message || batch?.stage || batch?.step || (found ? "Drafting cover letters and screening answers..." : "Searching for matching roles...");
  return (
    <div className="fade-up rounded-xl border border-[#D4AF37]/30 bg-[#141417] p-4" data-testid="auto-live-progress">
      <div className="mb-2 flex items-center gap-2 text-sm">
        <Radio className="h-4 w-4 animate-pulse text-[#D4AF37]" />
        <span className="flex-1 text-zinc-200" data-testid="auto-live-status">{msg}</span>
        <span className="font-mono text-xs text-[#F3C649]" data-testid="auto-live-count">{found}/{total}</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-[#27272A]"><div className="h-full rounded-full bg-[#D4AF37] transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
      {ago != null && <div className="mt-2 text-[11px] text-zinc-500" data-testid="auto-live-updated">Live · updated {ago}s ago</div>}
    </div>
  );
};
